import { resourceWithPagination } from './utils';

const RESOURCE_NAME = 'articles';

export default function articlesRoutes(context) {
  resourceWithPagination(context, {
    resource: RESOURCE_NAME,
    paginatedSerializer: 'paginated-articles',
    except: ['create', 'update'],
  });
}
